module.exports = __webpack_public_path__ + "static/media/cm.27f49e55.svg";